import React , {useEffect, useState}from 'react';
import Drawer from "components/Drawers/Drawer";
import ScheduledList from 'components/Drawers/DrawerScheduledList/ScheduledList';
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR
import { verifyClusterScheduleOrders } from 'utils';

let actions = [];

const DrawerScheduledList= () => {
    if(!verifyClusterScheduleOrders(false)) return '';

    const [scheduledInfo, setScheduledInfo] = useState({});

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.SCHEDULED_LIST_OPEN, _data));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _data = (payload) => {
        setScheduledInfo(payload.value);
    }

    return (
        <Drawer
            customClass='drawer-scheduled-list' 
            actionOpen={actionsType.DRAWER.SCHEDULED_LIST_OPEN} 
            actionClose={actionsType.DRAWER.SCHEDULED_LIST_CLOSE}>
            <ScheduledList data={scheduledInfo}/>

        </Drawer>
    );
}

export default DrawerScheduledList;